import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import * as Icons from "@element-plus/icons-vue";
import 'element-plus/dist/index.css'
import router from './routes'
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { createHead } from '@vueuse/head'


const app = createApp(App)
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
const head = createHead()
app.use(head)

// register the element Icons component
for (const [key, component] of Object.entries(Icons)) {
    app.component(key, component);
}

app.use(ElementPlus);
app.use(pinia);
app.use(router);


app.mount('#app')
